import { useTranslation } from "react-i18next";
import type { Song } from "../../model/launchpad";
import TileSection from "./TileSection";
import SongTile from "./SongTile";
import { MusicIcon } from "../ui/icons";
import { useSongPlatforms } from "./SongPlatformsProvider";

// Web port of WorshipSongsListView
// (HomeFeature/View/Component/WorshipSongsListView.swift).
//
// Like the app, this is a thin wrapper: TileSection does the layout and this
// only supplies the icon, title, and tile. PlaylistsSection is its twin — the
// two differ only in those three things.

export interface WorshipSongsSectionProps {
  songs: Song[];
  /**
   * Overrides the default tap behaviour. Left unset, tapping a song presents
   * the streaming-platforms sheet, the way SongTileButton does in the app.
   */
  onSongClick?: (song: Song) => void;
  usesGrid?: boolean;
}

export default function WorshipSongsSection(props: WorshipSongsSectionProps) {
  const { t } = useTranslation("library");
  const presentPlatforms = useSongPlatforms();
  const handleClick = props.onSongClick ?? presentPlatforms;

  return <TileSection
    icon={<MusicIcon />}
    title={t("worshipSongs")}
    items={props.songs}
    getKey={(song) => song.id}
    usesGrid={props.usesGrid}
    renderTile={(song, tileWidth) => (
      <SongTile
        title={song.attributes.title}
        artistName={song.attributes.artist.name}
        artworkUrl={song.attributes.artworkURL}
        width={tileWidth}
        onClick={() => handleClick?.(song)}
      />
    )}
  />
}
